// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customize_dot__TrSPi{
    height: 12px;
    width: 12px;
    margin-top: 6px;
    margin-right: 6px;
    border-radius: 50%;
    background: #FF7020;
}
.customize_dott__U5Ewu{
    height: 35px;
    width: 35px;
    margin-right: 6px;
    border-radius: 50%;
    background: #FF7020;
}
.customize_dott1__MUN\\+m{
    height: 35px;
    width: 35px;
    /* margin-top: 6px; */
    margin-right: 6px;
    border-radius: 50%;
    background: #F5C400;
}
.customize_dott2__EpUid{
    height: 35px;
    width: 35px;
    /* margin-top: 6px; */
    margin-right: 6px;
    border-radius: 50%;
    /* background: linear-gradient(#F5C400,#FF7020); */
    background: #7e7803;
}
.customize_dott3__FaFnZ{
    height: 35px;
    width: 35px;
    /* margin-top: 6px; */
    margin-right: 6px;
    border-radius: 50%;
    background: #3D05B6;
}
.customize_head__xDPg7{
    padding-left: 0%;
}
.customize_homepagehead__0VVuP{
    display: flex;
    justify-content: space-between;
    height: auto;
    align-items: center;
}
.customize_uploader__GtBk\\+{
    border: 1px dashed #568EFE;
    width:100%;
    height: auto;
    background-color: #F3F7FF;
    padding-top: 5px;
    display: flex;
    padding-left: 10px;
}

.customize_empty__fRrRG{
    border: 1px dashed red;
    width:100%;
    height: auto;
    background-color: #F3F7FF;
    padding-top: 5px;
    display: flex;
    padding-left: 10px;
}

.customize_spanColor__Y0ZZL{
    color: #568EFE;
}
/* .divBorder{
 border:1px solid black;
} */

.customize_headInput__hpmCy{
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 50%;
    align-items: center;
    transform: translateX(-50%) translateY(-50%);
}
/* .headinp{
    background-color: #568EFE;
} */
/* .brandcolor{
    position: absolute;
    top:40%;
    left:70%;
    -webkit-transform: translateX(-40%) translateY(-70%);
    transform: translateX(-40%) translateY(-70%);
    height: 200px;
} */
.customize_ncentivaColor__rnXeO{
    color: #FF7020;
}
.customize_headimage__dqEL8 ~ div{
    /* display: none; */
    opacity: 0;
    /* border:1px solid black */
}
.customize_headimage__dqEL8:hover ~ div{
    opacity: 1;
}

.customize_headDiv__s3V1c ~ div{
    /* display: none; */
    opacity: 0;
    /* border:1px solid black */
}
.customize_headDiv__s3V1c:hover ~ div{
    opacity: 1;
}
.customize_video__3Mjrz ~ div{
    /* display: none; */
    opacity: 0;
    /* border:1px solid black */
}
.customize_video__3Mjrz:hover ~ div{
    opacity: 1;
}
.customize_headInput__hpmCy:hover{
    opacity: 1;
}
.customize_loaderContainer__0ofLx {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    /* background: rgba(0, 0, 0, 0.5); */
    z-index: 1;
    /* top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%); */
}
.customize_mainCont__2OE0t{
    position: relative;
}

.customize_spinner__VWrLk {
    width: 64px;
    height: 64px;
    border: 8px solid;
    border-color: #3d5af1 transparent #3d5af1 transparent;
    border-radius: 50%;
    animation: customize_spin-anim__ErErC 1.2s linear infinite;
}

@keyframes customize_spin-anim__ErErC {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.customize_showlogo__6ZCVy{
    width:200px;
    height:100%;
    margin-top:1rem;
    align-items: center;
    margin-right: 1rem;
}
.customize_logoimg__nrWQX{
    width : 200px;
    height: 40px;
    object-fit : fill;
}
.customize_footerlogo__0RIO0{
    width : 80px;
    height: 50px;
    box-shadow: inset 0 0 0 2000px rgb(250, 245, 245);
}
.customize_footerlogo__0RIO0>img{
    width:100%;
    height: 100%;
    object-fit: fill;
}
.customize_emaillogos__GyYbL{
    width: 210px;
    padding: 2px;
    box-shadow: inset 0 0 0 2000px rgb(250, 245, 245);
}
.customize_emaillogos__GyYbL>img{
    width: 80px;
    height:50px;
}
.customize_cpybutton__FGNOI{
    position: relative;
    top: -8px;
    margin: 0px 10px;
}


/* pdf uolad modal css */
.customize_container__B4Xej {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .customize_container__B4Xej .customize_text__j4eyE {
    margin-bottom: 10px;
  }
  
  .customize_container__B4Xej form {
    display: flex;
    flex-direction: column;
  }
  .customize_dn__hWzyN{
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
   
  }
  .customize_formContainer__phj6D {
    border-radius: 10px;
    max-width: 400px;
    border: 2px dashed #151935;
    height:100%;
    width:100%;
    /* display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; */
    margin-bottom: 20px;
    /* padding: 20px 0; */
    cursor: pointer;
    position: relative;
    /* box-shadow: 0px 8px 5px 2px rgb(180, 180, 180); */
    
  }
  
  .customize_formContainer__phj6D svg {
    width: 100px;
  }
  
  .customize_formContainer__phj6D span {
    color: #151935;
    font-size: 20px;
    font-weight: 600;
  }
  
  .customize_fileSelected__zVEod {
    width: 400px;
    margin-bottom: 20px;
    border-radius: 10px;
    /* box-shadow: 0 2px 2px 1px rgba(11, 11, 11, 0.1); */
    display: flex;
    align-items: center;
    height: 40px;
    animation: customize_fileSlected__K1SN\\+ 0.4s 1;
  }
  
  .customize_fileSelected__zVEod p {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 500;
    color: #151935;
    margin-bottom: 0px;
    padding: 0 10px;
  }
  @media screen and (max-width: 550px) {
    .customize_fileSelected__zVEod p {
        padding: 0 50px;
      }
  }
  @media screen and (max-width: 545px) {
    .customize_fileSelected__zVEod p {
        padding: 0 20px;
      }
  }
  @media screen and (max-width: 520px) {
    .customize_fileSelected__zVEod p {
        padding: 0 30px;
      }
  }
  @media screen and (max-width: 500px) {
    .customize_fileSelected__zVEod p {
        padding: 0 45px;
      }
  }
  @media screen and (max-width: 450px) {
    .customize_fileSelected__zVEod p {
        padding: 0 64px;
      }
  }
  
  @media screen and (max-width: 430px) {
    .customize_fileSelected__zVEod p {
        padding: 0 75px;
      }
  }
  
  .customize_fileSelected__zVEod p span img {
    width: 20px;
    height: 20px;
  }
  
  @keyframes customize_fileSlected__K1SN\\+ {
    from {
      transform: translate(0px, -10px);
      opacity: 0;
    }
    to {
      transform: translate(0px, 0px);
      opacity: 1;
    }
  }

  
@media only screen and (max-width: 767px) {
    .customize_uploader__GtBk\\+ {
        display: block;
        margin-top: 10px;
    }
    .customize_logoimg__nrWQX{
        width : auto;
    }
    .customize_cpybutton__FGNOI{
        margin: 0;
        top:0px;
    }
}
.customize_custom-modal-res__h92Xi .customize_modal-dialog__6o4Nx {
    max-width: 800px;
    margin: 1.75rem auto;
  }
  
  @media (max-width: 991px) {
    .customize_custom-modal-res__h92Xi .customize_modal-dialog__6o4Nx {
      max-width: 90%;
      margin: 1rem auto;
    }
  }
  
  @media (max-width: 575px) {
    .customize_custom-modal-res__h92Xi .customize_modal-dialog__6o4Nx {
      max-width: 95%;
      margin: 0.5rem auto;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/customize.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,kDAAkD;IAClD,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;AACA;;GAEG;;AAEH;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mBAAmB;IAEnB,4CAA4C;AAChD;AACA;;GAEG;AACH;;;;;;;GAOG;AACH;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,2BAA2B;AAC/B;AACA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,2BAA2B;AAC/B;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,2BAA2B;AAC/B;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,UAAU;IACV;;;mDAG+C;AACnD;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qDAAqD;IACrD,kBAAkB;IAClB,0DAAyC;AAC7C;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,iDAAiD;AACrD;AACA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;;AAGA,wBAAwB;AACxB;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;;EAEjB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,WAAW;IACX,UAAU;IACV;;;0BAGsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,oDAAoD;;EAEtD;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,+CAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE;QACI,eAAe;MACjB;EACJ;EACA;IACE;QACI,eAAe;MACjB;EACJ;EACA;IACE;QACI,eAAe;MACjB;EACJ;EACA;IACE;QACI,eAAe;MACjB;EACJ;EACA;IACE;QACI,eAAe;MACjB;EACJ;;EAEA;IACE;QACI,eAAe;MACjB;EACJ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE;MACE,gCAAgC;MAChC,UAAU;IACZ;IACA;MACE,8BAA8B;MAC9B,UAAU;IACZ;EACF;;;AAGF;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;IACA;QACI,SAAS;QACT,OAAO;IACX;AACJ;AACA;IACI,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE;MACE,cAAc;MACd,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,cAAc;MACd,mBAAmB;IACrB;EACF","sourcesContent":[".dot{\n    height: 12px;\n    width: 12px;\n    margin-top: 6px;\n    margin-right: 6px;\n    border-radius: 50%;\n    background: #FF7020;\n}\n.dott{\n    height: 35px;\n    width: 35px;\n    margin-right: 6px;\n    border-radius: 50%;\n    background: #FF7020;\n}\n.dott1{\n    height: 35px;\n    width: 35px;\n    /* margin-top: 6px; */\n    margin-right: 6px;\n    border-radius: 50%;\n    background: #F5C400;\n}\n.dott2{\n    height: 35px;\n    width: 35px;\n    /* margin-top: 6px; */\n    margin-right: 6px;\n    border-radius: 50%;\n    /* background: linear-gradient(#F5C400,#FF7020); */\n    background: #7e7803;\n}\n.dott3{\n    height: 35px;\n    width: 35px;\n    /* margin-top: 6px; */\n    margin-right: 6px;\n    border-radius: 50%;\n    background: #3D05B6;\n}\n.head{\n    padding-left: 0%;\n}\n.homepagehead{\n    display: flex;\n    justify-content: space-between;\n    height: auto;\n    align-items: center;\n}\n.uploader{\n    border: 1px dashed #568EFE;\n    width:100%;\n    height: auto;\n    background-color: #F3F7FF;\n    padding-top: 5px;\n    display: flex;\n    padding-left: 10px;\n}\n\n.empty{\n    border: 1px dashed red;\n    width:100%;\n    height: auto;\n    background-color: #F3F7FF;\n    padding-top: 5px;\n    display: flex;\n    padding-left: 10px;\n}\n\n.spanColor{\n    color: #568EFE;\n}\n/* .divBorder{\n border:1px solid black;\n} */\n\n.headInput{\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    align-items: center;\n    -webkit-transform: translateX(-50%) translateY(-50%);\n    transform: translateX(-50%) translateY(-50%);\n}\n/* .headinp{\n    background-color: #568EFE;\n} */\n/* .brandcolor{\n    position: absolute;\n    top:40%;\n    left:70%;\n    -webkit-transform: translateX(-40%) translateY(-70%);\n    transform: translateX(-40%) translateY(-70%);\n    height: 200px;\n} */\n.ncentivaColor{\n    color: #FF7020;\n}\n.headimage ~ div{\n    /* display: none; */\n    opacity: 0;\n    /* border:1px solid black */\n}\n.headimage:hover ~ div{\n    opacity: 1;\n}\n\n.headDiv ~ div{\n    /* display: none; */\n    opacity: 0;\n    /* border:1px solid black */\n}\n.headDiv:hover ~ div{\n    opacity: 1;\n}\n.video ~ div{\n    /* display: none; */\n    opacity: 0;\n    /* border:1px solid black */\n}\n.video:hover ~ div{\n    opacity: 1;\n}\n.headInput:hover{\n    opacity: 1;\n}\n.loaderContainer {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    /* background: rgba(0, 0, 0, 0.5); */\n    z-index: 1;\n    /* top: 50%;\n    left: 50%;\n    -webkit-transform: translateX(-50%) translateY(-50%);\n    transform: translateX(-50%) translateY(-50%); */\n}\n.mainCont{\n    position: relative;\n}\n\n.spinner {\n    width: 64px;\n    height: 64px;\n    border: 8px solid;\n    border-color: #3d5af1 transparent #3d5af1 transparent;\n    border-radius: 50%;\n    animation: spin-anim 1.2s linear infinite;\n}\n\n@keyframes spin-anim {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.showlogo{\n    width:200px;\n    height:100%;\n    margin-top:1rem;\n    align-items: center;\n    margin-right: 1rem;\n}\n.logoimg{\n    width : 200px;\n    height: 40px;\n    object-fit : fill;\n}\n.footerlogo{\n    width : 80px;\n    height: 50px;\n    box-shadow: inset 0 0 0 2000px rgb(250, 245, 245);\n}\n.footerlogo>img{\n    width:100%;\n    height: 100%;\n    object-fit: fill;\n}\n.emaillogos{\n    width: 210px;\n    padding: 2px;\n    box-shadow: inset 0 0 0 2000px rgb(250, 245, 245);\n}\n.emaillogos>img{\n    width: 80px;\n    height:50px;\n}\n.cpybutton{\n    position: relative;\n    top: -8px;\n    margin: 0px 10px;\n}\n\n\n/* pdf uolad modal css */\n.container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .container .text {\n    margin-bottom: 10px;\n  }\n  \n  .container form {\n    display: flex;\n    flex-direction: column;\n  }\n  .dn{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n   \n  }\n  .formContainer {\n    border-radius: 10px;\n    max-width: 400px;\n    border: 2px dashed #151935;\n    height:100%;\n    width:100%;\n    /* display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center; */\n    margin-bottom: 20px;\n    /* padding: 20px 0; */\n    cursor: pointer;\n    position: relative;\n    /* box-shadow: 0px 8px 5px 2px rgb(180, 180, 180); */\n    \n  }\n  \n  .formContainer svg {\n    width: 100px;\n  }\n  \n  .formContainer span {\n    color: #151935;\n    font-size: 20px;\n    font-weight: 600;\n  }\n  \n  .fileSelected {\n    width: 400px;\n    margin-bottom: 20px;\n    border-radius: 10px;\n    /* box-shadow: 0 2px 2px 1px rgba(11, 11, 11, 0.1); */\n    display: flex;\n    align-items: center;\n    height: 40px;\n    animation: fileSlected 0.4s 1;\n  }\n  \n  .fileSelected p {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    font-size: 18px;\n    font-weight: 500;\n    color: #151935;\n    margin-bottom: 0px;\n    padding: 0 10px;\n  }\n  @media screen and (max-width: 550px) {\n    .fileSelected p {\n        padding: 0 50px;\n      }\n  }\n  @media screen and (max-width: 545px) {\n    .fileSelected p {\n        padding: 0 20px;\n      }\n  }\n  @media screen and (max-width: 520px) {\n    .fileSelected p {\n        padding: 0 30px;\n      }\n  }\n  @media screen and (max-width: 500px) {\n    .fileSelected p {\n        padding: 0 45px;\n      }\n  }\n  @media screen and (max-width: 450px) {\n    .fileSelected p {\n        padding: 0 64px;\n      }\n  }\n  \n  @media screen and (max-width: 430px) {\n    .fileSelected p {\n        padding: 0 75px;\n      }\n  }\n  \n  .fileSelected p span img {\n    width: 20px;\n    height: 20px;\n  }\n  \n  @keyframes fileSlected {\n    from {\n      transform: translate(0px, -10px);\n      opacity: 0;\n    }\n    to {\n      transform: translate(0px, 0px);\n      opacity: 1;\n    }\n  }\n\n  \n@media only screen and (max-width: 767px) {\n    .uploader {\n        display: block;\n        margin-top: 10px;\n    }\n    .logoimg{\n        width : auto;\n    }\n    .cpybutton{\n        margin: 0;\n        top:0px;\n    }\n}\n.custom-modal-res .modal-dialog {\n    max-width: 800px;\n    margin: 1.75rem auto;\n  }\n  \n  @media (max-width: 991px) {\n    .custom-modal-res .modal-dialog {\n      max-width: 90%;\n      margin: 1rem auto;\n    }\n  }\n  \n  @media (max-width: 575px) {\n    .custom-modal-res .modal-dialog {\n      max-width: 95%;\n      margin: 0.5rem auto;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dot": `customize_dot__TrSPi`,
	"dott": `customize_dott__U5Ewu`,
	"dott1": `customize_dott1__MUN+m`,
	"dott2": `customize_dott2__EpUid`,
	"dott3": `customize_dott3__FaFnZ`,
	"head": `customize_head__xDPg7`,
	"homepagehead": `customize_homepagehead__0VVuP`,
	"uploader": `customize_uploader__GtBk+`,
	"empty": `customize_empty__fRrRG`,
	"spanColor": `customize_spanColor__Y0ZZL`,
	"headInput": `customize_headInput__hpmCy`,
	"ncentivaColor": `customize_ncentivaColor__rnXeO`,
	"headimage": `customize_headimage__dqEL8`,
	"headDiv": `customize_headDiv__s3V1c`,
	"video": `customize_video__3Mjrz`,
	"loaderContainer": `customize_loaderContainer__0ofLx`,
	"mainCont": `customize_mainCont__2OE0t`,
	"spinner": `customize_spinner__VWrLk`,
	"spin-anim": `customize_spin-anim__ErErC`,
	"showlogo": `customize_showlogo__6ZCVy`,
	"logoimg": `customize_logoimg__nrWQX`,
	"footerlogo": `customize_footerlogo__0RIO0`,
	"emaillogos": `customize_emaillogos__GyYbL`,
	"cpybutton": `customize_cpybutton__FGNOI`,
	"container": `customize_container__B4Xej`,
	"text": `customize_text__j4eyE`,
	"dn": `customize_dn__hWzyN`,
	"formContainer": `customize_formContainer__phj6D`,
	"fileSelected": `customize_fileSelected__zVEod`,
	"fileSlected": `customize_fileSlected__K1SN+`,
	"custom-modal-res": `customize_custom-modal-res__h92Xi`,
	"modal-dialog": `customize_modal-dialog__6o4Nx`
};
export default ___CSS_LOADER_EXPORT___;
